export default {
  computed: {
    $roomCall() {
      return this.$store.state.call.roomCall
    },
  }
}
